import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import FoldText from "@/components/FoldText/FoldText";

const EASE = [0.16, 1, 0.3, 1];

const SubmittedPanel = ({ email, onReset }) => (
  <motion.div
    key="submitted"
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: EASE }}
    data-testid="detector-submitted-panel"
    className="relative bg-[#121214] border border-white/10 p-8 sm:p-10 text-center"
  >
    <div className="absolute -top-3 -left-3 w-8 h-8 border-t-2 border-l-2 border-[#FFD166]/50" />
    <div className="absolute -bottom-3 -right-3 w-8 h-8 border-b-2 border-r-2 border-[#FFD166]/50" />

    <CheckCircle2 size={40} className="mx-auto text-[#FFD166]" />

    <h2 className="mt-5 font-display font-semibold text-2xl text-white">
      <FoldText text="Check your inbox" splitBy="word" trigger="mount" fontSize="inherit" fontWeight="inherit" color="inherit" />
    </h2>

    <p className="mt-3 text-sm text-[#A1A1AA] font-light leading-relaxed max-w-sm mx-auto">
      Your plain-English Claim Check summary is on its way to{" "}
      <span className="text-white">{email}</span>. Keep an eye on your inbox — and your spam
      folder, just in case.
    </p>

    <button
      type="button"
      data-testid="detector-reset-btn"
      onClick={onReset}
      className="mt-8 font-display text-xs tracking-[0.3em] text-[#9D4EDD] border border-[#8A2BE2]/60 px-6 py-3 hover:bg-[#8A2BE2]/10 hover:border-[#9D4EDD] transition-colors duration-300"
    >
      START OVER
    </button>
  </motion.div>
);

export default SubmittedPanel;
